import { render, staticRenderFns } from "./amendScreening.vue?vue&type=template&id=6fb7b25c"
import script from "./amendScreening.vue?vue&type=script&lang=js"
export * from "./amendScreening.vue?vue&type=script&lang=js"
import style0 from "./amendScreening.vue?vue&type=style&index=0&id=6fb7b25c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports